import { GET_ACTIONPLAN_LIST } from '_revamp/redux/action/admin/action_plan';

const initialState = {
  data: [],
};

const actionPlan = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ACTIONPLAN_LIST: {
      return {
        ...state,
        data: payload.rows,
      };
    }

    default:
      return state;
  }
};

export default actionPlan;
